export { SimpleText } from './SimpleText'
export type { ButtonProps, SimpleTextItem, SimpleTextProps } from './SimpleText'
